import type { TSerializedWidget } from 'src/entities/workspace/types';
import { DayDepthChartWidgetEntity } from 'src/pages/dashboard/features/well-day-depth-widget/DayDepthChartWidget.entity';
import { parseDayDepthChartWidgetInternalState } from 'src/pages/dashboard/features/well-day-depth-widget/parseDayDepthChartWidget';

export function mapDayDepthChartWidget(widget: TSerializedWidget, index: number): DayDepthChartWidgetEntity {
  const internalState = parseDayDepthChartWidgetInternalState(widget.internalState);

  const newFilterWidget = new DayDepthChartWidgetEntity(
    {
      wellId: internalState.wellId,
      stateParams: internalState.stateParams,
      type: 'time-vs-depth-widget',
    },
    {
      uuid: widget.uuid,
      isPinned: !!widget.isPinned,
      zIndex: index + 1,
      isFullscreen: widget.isFullscreen ?? false,
      position: {
        x: widget?.position?.x ?? 0,
        y: widget?.position?.y ?? 0,
      },
      size: {
        w: widget.size?.w ?? 59,
        h: widget.size?.h ?? 316,
      },
      groupId: widget.groupId,
      isGroupsDefaultOpened: false,
    },
  );

  return newFilterWidget;
}
